// src/utils/orderHelpers.js

export const splitOrdersByItems = (orders) => {
  const splitOrders = [];

  orders.forEach(order => {
    if (order.items && order.items.length > 0) {
      order.items.forEach((item, index) => {
        const splitOrder = {
          ...order,
          id: `${order.id}-item-${index}`,
          original_order_id: order.id,
          item_index: index,
          items: [item],

          // Recalculate totals for this single item
          subtotal: parseFloat(item.item_total || 0).toFixed(2),
          tax: (
            (parseFloat(item.item_total || 0) / parseFloat(order.subtotal || 1)) *
            parseFloat(order.tax || 0)
          ).toFixed(2),
          shipping: (
            (parseFloat(item.item_total || 0) / parseFloat(order.subtotal || 1)) *
            parseFloat(order.shipping || 0)
          ).toFixed(2),
          discount_amount: order.discount_amount ? (
            (parseFloat(item.item_total || 0) / parseFloat(order.subtotal || 1)) *
            parseFloat(order.discount_amount || 0)
          ).toFixed(2) : 0,
          total_amount: (
            parseFloat(item.item_total || 0) +
            ((parseFloat(item.item_total || 0) / parseFloat(order.subtotal || 1)) * parseFloat(order.tax || 0)) +
            ((parseFloat(item.item_total || 0) / parseFloat(order.subtotal || 1)) * parseFloat(order.shipping || 0)) -
            (order.discount_amount ? ((parseFloat(item.item_total || 0) / parseFloat(order.subtotal || 1)) * parseFloat(order.discount_amount || 0)) : 0)
          ).toFixed(2),

          order_number: order.items.length > 1
            ? `${order.order_number}-${index + 1}`
            : order.order_number,

          total_items_in_order: order.items.length,
          original_order_number: order.order_number
        };

        splitOrders.push(splitOrder);
      });
    } else {
      splitOrders.push({
        ...order,
        original_order_id: order.id,
        item_index: 0,
        total_items_in_order: order.items?.length || 0,
        original_order_number: order.order_number
      });
    }
  });

  return splitOrders;
};

export const mergeOrderItems = (originalOrders, displayOrderId) => {
  // Check if this is a split order (contains '-item-')
  const isSplitOrder = displayOrderId.toString().includes('-item-');

  if (!isSplitOrder) {
    // Not a split order, return the original order as is
    return originalOrders.find(o => o.id.toString() === displayOrderId.toString());
  }

  // Extract the original order ID and item index from the display order ID
  const [originalId, itemPart] = displayOrderId.toString().split('-item-');
  const itemIndex = parseInt(itemPart);

  // Find the original order
  const originalOrder = originalOrders.find(o => o.id.toString() === originalId);

  if (!originalOrder || !originalOrder.items || !originalOrder.items[itemIndex]) {
    return null;
  }

  // Return order with only the specific item
  const item = originalOrder.items[itemIndex];

  return {
    ...originalOrder,
    items: [item], // Only include this specific item

    // Recalculate totals for this single item
    subtotal: parseFloat(item.item_total || 0).toFixed(2),
    tax: (
      (parseFloat(item.item_total || 0) / parseFloat(originalOrder.subtotal || 1)) *
      parseFloat(originalOrder.tax || 0)
    ).toFixed(2),
    shipping: (
      (parseFloat(item.item_total || 0) / parseFloat(originalOrder.subtotal || 1)) *
      parseFloat(originalOrder.shipping || 0)
    ).toFixed(2),
    discount_amount: originalOrder.discount_amount ? (
      (parseFloat(item.item_total || 0) / parseFloat(originalOrder.subtotal || 1)) *
      parseFloat(originalOrder.discount_amount || 0)
    ).toFixed(2) : 0,
    total_amount: (
      parseFloat(item.item_total || 0) +
      ((parseFloat(item.item_total || 0) / parseFloat(originalOrder.subtotal || 1)) * parseFloat(originalOrder.tax || 0)) +
      ((parseFloat(item.item_total || 0) / parseFloat(originalOrder.subtotal || 1)) * parseFloat(originalOrder.shipping || 0)) -
      (originalOrder.discount_amount ? ((parseFloat(item.item_total || 0) / parseFloat(originalOrder.subtotal || 1)) * parseFloat(originalOrder.discount_amount || 0)) : 0)
    ).toFixed(2),

    // Keep the split order number
    order_number: originalOrder.items.length > 1
      ? `${originalOrder.order_number}-${itemIndex + 1}`
      : originalOrder.order_number,

    // Add metadata
    total_items_in_order: originalOrder.items.length,
    original_order_number: originalOrder.order_number,
    item_index: itemIndex
  };
};

export const getCustomizationPreview = (customizations) => {
  if (!customizations) return [];
  const preview = [];

  if (customizations.width && customizations.height) {
    preview.push({
      label: 'Size',
      value: `${customizations.width}" × ${customizations.height}"`,
      id: 'size'
    });
  }

  if (customizations.fields && customizations.fields.length > 0) {
    customizations.fields.slice(0, 2).forEach((field, idx) => {
      preview.push({
        label: field.name,
        value: field.selected_value || 'N/A',
        id: `field-${idx}`
      });
    });
  }

  return preview;
};